<template>
  <div class="propaganda">
    <div class="content">
      <div class="title">自贸港旅游航空总部（全过程造价咨询）</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img1.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚旅文旅游总部投资开发有限公司</li>
            <li>项目概况：项目总用地面积4.14万平方米，总建筑面积21万平方米，计容建筑面积约为14.5万平方米，地下建筑面积约6.5万平方米，主要建设内容为土建、装修及配套设施。</li>
            <li>总投资: 25亿元人民币</li>
            <li>项目区位: 三亚市吉阳区迎宾路与海螺路交叉口加油站北侧</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚市天涯区西瓜、芒果片区棚户区改造（一期）项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img2.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚城市发展联合投资有限公司</li>
            <li>项目概况：项目总用地面积87641平方米，总建筑面积309267.46平方米，计容建筑面积为219100平方米，主要建设内容为土建工程、给排水工程、消防工程、电气工程、暖通工程。</li>
            <li>总投资：133.62亿元人民币</li>
            <li>项目区位：三亚市天涯区西瓜、芒果村</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚凤凰海鲜广场及商业综合体二期项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img3.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚市天涯区海坡村民委员会</li>
            <li>项目概况：项目总用地面积61.2亩，总建筑面积17.29万平方米，本项目分为三个标段，一标段建筑面积5.90万平方米，二标段建筑面积5.51万平方米，三标段建筑面积5.87万平方米</li>
            <li>总投资：6.5亿元人民币</li>
            <li>项目区位：三亚市三亚湾鲁能美丽五区旁</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚市抱坡新城片区（南区）保障性住房项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img4.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚市住房保障管理中心</li>
            <li>项目概况：项目规划用地面积约115463.08平方米，总建筑面积约523724.65平方米</li>
            <li>总投资：20.36亿元</li>
            <li>项目区位：三亚市河东区海罗村委会南侧</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">海南华昌南燕湾项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img5.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：海南华昌旅游开发有限公司</li>
            <li>项目概况：项目总用地面积206109平方米，项目总建筑面积约125770平方米。其中酒店1栋建筑面积约为21391平方米。居住类别墅总建筑面积约为104379平方米,共224户。</li>
            <li>项目区位：万宁市礼纪镇南燕湾区</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">海南雅居乐清水湾项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img6.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：海南雅居乐房地产开发有限公司</li>
            <li>项目概况：建筑面积32.35万平米，别墅:180-567平方，洋房115-291平方;洋房:68-176平方;瀚海银滩:洋房:77-335平方，别墅297-1415平方(一线海景)。</li>
            <li>总投资：造价约人民币约40亿元</li>
            <li>项目区位：距离三亚凤凰机场仅45分钟车程， 市区30分钟车程，2011年竣工的海南东环城际轻轨，将缩短清水湾至三亚和海口的时间。便捷的航空、高速公路、城市轻轨、空中巴士，全方位的立体交通网络畅达岛内外。</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">国家海岸·保利海棠项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img7.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：保利（三亚）房地产开发有限公司</li>
            <li>工程概况：国家海岸·保利海棠项目，总占地面积47.45公顷，总建面约50万㎡。项目集会展、商业、住宅、休闲养生于一体，项目分四期开发.</li>
            <li>总投资：造价约人民币4亿元</li>
            <li>项目区位：三亚市国家海岸海棠湾片区南部</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚中环广场</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img8.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚中铁保丰置业有限公司</li>
            <li>工程概况：中环广场项目总用地面积17101.12平方米，总建筑面积99187.61平方米。主要建设内容为商业广场的土建、装修及配套设施。</li>
            <li>总投资：造价约人民币2亿元</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚绿地悦澜湾</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img9.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：绿地集团三亚置业有限公司会</li>
            <li>工程概况：绿地悦澜湾占地213亩，20栋纯板式瞰海公寓和45栋退台式墅质洋房；</li>
            <li>总投资：造价约人民币11.4亿元</li>
            <li>项目区位：三亚东城区，紧邻榆亚大道。</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚青田小镇</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img10.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：儋州恒大滨海投资有限公司</li>
            <li>项目概况：占地面积87.6公顷，总建筑面积452520㎡。</li>
            <li>总投资：造价约人民币11亿元</li>
            <li>项目区位：坐落于海棠湾开发区南区的西南部，田岸后大岭的东南侧山脚下</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚海棠湾龙海风情小镇（安居工程）</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img11.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚新天房置业有限公司</li>
            <li>工程概况：总建筑面积44.76万平方米，还迁户数1738户，还迁人口7473人。还迁住宅建筑面积33.73万平方米，配套服务设施建筑面积2.77万平方米，商业建筑面积8.26万平方米。建设内容包括联排低层住宅，安置公寓，商业楼、绿化工程，道路及广场工程、室外给排水工程、室外供配电工程、室外消防工程、地下停车场及公建配套建筑设施等内容。</li>
            <li>总投资：造价约人民币19.7亿元</li>
            <li>项目地区: 项目位于海南省三亚市海棠湾北区的风塘片区。</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">“华闻传媒·新海岸壹号”工程</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img12.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：海南椰德利房地产开发有限公司</li>
            <li>项目概况：项目总占地面积62883平方米(约94.3亩)，总建筑面积3.2万平方米</li>
            <li>总投资：造价约人民币24.5亿元</li>
            <li>项目区位：“华闻传媒·新海岸壹号”位于海口美兰区桂林洋海滨旅游区东部林海一路。</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">崖州湾壹号项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img13.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚（保利）房地产开发有限公司</li>
            <li>工程概况：项目总建筑面积27万平方米，项目总工拥有1400套公共租赁房 。</li>
            <li>总投资：造价约人民币6亿元</li>
            <li>项目区位：位于崖城南滨新城。</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚海棠湾洲际度假酒店工程</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img14.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚新天房置业有限公司</li>
            <li>工程概况：地处国家海岸 - 海棠湾，占地15万平方米，14层楼宇面海而立，3,000平方米开放式大堂</li>
            <li>总投资：造价约人民币19亿元</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚亿隆温德姆酒店工程</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img15.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚亿隆置业有限公司</li>
            <li>工程概况：项目兴建三幢八层高精装修的酒店，总建筑面积为83710平方米。</li>
            <li>总投资：造价约人民币7.6亿元</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="title">三亚财经论坛中心项目</div>
      <el-row>
        <el-col :xs="24" :md="16">
          <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/propaganda/img16.png" />
        </el-col>
        <el-col :xs="24" :md="8">
          <ul>
            <li>建设单位：三亚（保利）房地产开发有限公司</li>
            <li>工程概况：总建筑面积约为175000平方米，</li>
            <li>总投资：造价约人民币20亿元</li>
            <li>项目区位：三亚市海棠湾</li>
          </ul>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>
<style scoped>
  .img{width: 100%;height: auto;}
  .title{padding: 20px 0px;font-weight: bold;}
  ul li{padding-bottom: 20px;font-size: 20px;text-align: justify;}
  ul li:last-child{padding-bottom: none;}
  .content{border: 1px solid #f2f2f2;border-radius: 10px;padding: 20px;margin-bottom: 20px;}
</style>



// WEBPACK FOOTER //
// src/pages/propaganda.vue